<template>
  <div class="buttons is-centered">
    <div v-if="$i18n.locale === 'br'">
      <b-button
        id="download-csv"
        class="is-button-secondary"
        icon-left="far fa-file-csv"
        rounded
        @click="downloadBoletos">
        Baixar lista de boletos
      </b-button>
    </div>
    <div v-if="$i18n.locale === 'cl' || $i18n.locale === 'br' || $i18n.locale === 'pe'">
      <b-button
        id="button-filter"
        data-cy="button-filter"
        class="is-button-secondary"
        icon-left="fas fa-filter"
        rounded
        @click="$emit('filters')">
        Filtrar
      </b-button>
      <b-button
        id="download-excel"
        class="is-button-secondary"
        icon-left="far fa-file-excel"
        rounded
        :disabled="clients.length === 0"
        @click="downloadDefaultingClientsData">
        Clientes Morosos
      </b-button>
    </div>
    <div v-if="$i18n.locale === 'cl'">
      <b-tooltip
        :label="'Descarga las gestiones de mora de de estos clientes creadas en los últimos 60 días'">
        <b-button
          id="download-clients-defaults"
          icon-left="far fa-file-excel"
          class="is-button-secondary"
          :loading="downloadingClientsDefaults"
          rounded
          @click="downloadClientsDefaults">
          Gestiones de mora
        </b-button>
      </b-tooltip>
    </div>
  </div>
</template>
<script>
import zipcelx from 'zipcelx';
import { getClientsDefaults } from '@/application/services/api-clients/query-stack';
import { dateToFormatedString } from '@/infrastructure/date';
import { BoletosClient } from '@/application/services/api-clients/boletos';
import notification from '@/ui/mixins/notification';

export default {
  mixins: [notification],
  props: {
    clients: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      downloadingClientsDefaults: false
    };
  },
  methods: {
    downloadDefaultingClientsData() {
      const header = [
        { value: this.$t('collection.clientId'), type: 'string' },
        { value: this.$t('collection.name'), type: 'string' },
        { value: this.$t('collection.lastName'), type: 'string' },
        { value: this.$t('collection.idNumber'), type: 'string' },
        { value: this.$t('collection.email'), type: 'string' },
        { value: this.$t('collection.phone'), type: 'string' },
        { value: this.$t('collection.lateDays'), type: 'string' },
        { value: this.$t('collection.latePaymentsOperations'), type: 'string' },
        { value: this.$t('collection.latePaymentsOperationsQuantity'), type: 'string' },
        { value: this.$t('collection.latePayments'), type: 'string' },
        { value: this.$t('collection.investor'), type: 'string' }
      ];
      const data = [header];
      this.clients.forEach(x => {
        data.push([
          { value: x._id, type: 'string' },
          { value: x.name, type: 'string' },
          { value: x.lastName, type: 'string' },
          { value: x.idNumber, type: 'string' },
          { value: x.email, type: 'string' },
          { value: `+${x.phone}`, type: 'string' },
          { value: x.numberOfDefaultingDays, type: 'number' },
          { value: x.defaultingOperations.map(y => `${y.companyOperationId} (${y.numberOfDefaultingMonths})`).join(', '), type: 'string' },
          { value: x.defaultingOperations.length, type: 'number' },
          { value: x.totalNumberOfDefaultingPayments, type: 'number' },
          { value: x.defaultingOperations.map(y => `${y.lastInvestorName} (${y.companyOperationId})`).join(', '), type: 'string' }
        ]);
      });
      const config = {
        filename: `ClientesMorosos_${new Date().toISOString().substring(0, 10)}`,
        sheet: { data }
      };
      zipcelx(config);
    },
    async downloadClientsDefaults() {
      this.downloadingClientsDefaults = true;
      const date = new Date();
      date.setDate(date.getDate() + 1);
      const to = date.toISOString().substring(0, 10);
      date.setDate(date.getDate() - 61);
      const from = date.toISOString().substring(0, 10);

      let clientsWithDefaults;
      try {
        clientsWithDefaults = await getClientsDefaults(from, to);
      } catch (_error) {
        this.downloadingClientsDefaults = false;
        return;
      }
      const header = [
        { value: this.$t('collection.clientId'), type: 'string' },
        { value: this.$t('collection.idNumber'), type: 'string' },
        { value: this.$t('collection.registrationDate'), type: 'string' },
        { value: this.$t('collection.registrationHour'), type: 'string' },
        { value: this.$t('collection.executiveId'), type: 'string' },
        { value: this.$t('collection.executiveEmail'), type: 'string' },
        { value: this.$t('collection.executiveName'), type: 'string' },
        { value: this.$t('collection.communicationChannel'), type: 'string' },
        { value: this.$t('collection.comment'), type: 'string' },
        { value: this.$t('collection.replied'), type: 'string' },
        { value: this.$t('collection.paid'), type: 'string' },
        { value: this.$t('collection.canPay'), type: 'string' },
        { value: this.$t('collection.paymentCommitmen'), type: 'string' },
        { value: this.$t('collection.nextAction'), type: 'string' }
      ];
      const data = [header];
      clientsWithDefaults.data.forEach(c => {
        data.push([
          { value: c.id, type: 'string' },
          { value: c.attributes.rut, type: 'string' },
          { value: dateToFormatedString(c.attributes.createdAt).substring(0, 10), type: 'string' },
          { value: dateToFormatedString(c.attributes.createdAt).substring(11, 19), type: 'string' },
          { value: c.attributes.createdBy, type: 'string' },
          { value: c.attributes.createdByEmail, type: 'string' },
          { value: c.attributes.createdByName, type: 'string' },
          { value: c.attributes.contactMethod, type: 'string' },
          { value: c.attributes.comment, type: 'string' },
          { value: c.attributes.gotAnswerFromClient, type: 'string' },
          { value: c.attributes.alreadyPaid, type: 'string' },
          { value: c.attributes.isAbleToPay, type: 'string' },
          { value: c.attributes.willPayAt !== null ? dateToFormatedString(c.attributes.willPayAt, 'DD/MM/YYYY') : '', type: 'string' },
          { value: c.attributes.nextCollectionDate, type: 'string' }
        ]);
      });
      const config = {
        filename: `GestionCobranza_${new Date().toISOString().substring(0, 10)}`,
        sheet: { data }
      };
      zipcelx(config);
      this.downloadingClientsDefaults = false;
    },
    async downloadBoletos() {
      try {
        const boletoClient = new BoletosClient();
        const csvAsBlob = await boletoClient.download();
        const blobURL = URL.createObjectURL(new Blob([csvAsBlob]));

        const a = document.createElement('a');
        a.style = 'display: none';
        a.download = 'boletos.csv';
        a.href = blobURL;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (_e) {
        this.alert({ message: 'Ocorreu um problema ao baixar o arquivo' });
      }
    }
  }
};
</script>
